import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import { themeColors } from '../App';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const SectionContainer = (props) => {
  const { variant, removePadding, backgroundImage } = props;

  const backgroundColor = variant === 'secondary' ? themeColors.backgroundColors.lightMint : themeColors.backgroundColors.light;

  const backgroundStyles = backgroundImage ? {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
  } : {
    backgroundColor: backgroundColor,
  };
  const theme = useTheme();
  const largeUp = useMediaQuery(theme.breakpoints.up('lg'));
  const mediumUp = useMediaQuery(theme.breakpoints.up('md'));
  const smallUp = useMediaQuery(theme.breakpoints.up('sm'));

  let containerPadding = 
  largeUp ? { paddingLeft: '100px', paddingRight: '100px' } :
  mediumUp ? { paddingLeft: '50px', paddingRight: '50px' } :
  smallUp ? { paddingLeft: '25px', paddingRight: '25px' } :
  { paddingLeft: '5px', paddingRight: '5px' };

  if (removePadding) {
    containerPadding = { paddingLeft: 0, paddingRight: 0 };
  }
  
  return (
    <Grid container style={{ ...containerPadding, paddingTop: '50px', paddingBottom: '50px', ...backgroundStyles }}>
      {props.children}
    </Grid>
  );
} 

export default SectionContainer;
